import { OrganizationMetadataCreateDTO, OrganizationMetadataDTO, OrganizationMetadataPatchDTO } from '@om1/falcon-api'
import { ActionsUnion, createAction } from '@om1/platform-utils'

export enum GeneralSettingsActionTypes {
    GET_ORGANIZATION_SETTINGS = '@@generalSettings/get-organization-settings',
    SET_ORGANIZATION_SETTINGS = '@@generalSettings/set-organization-settings',
    SET_ORGANIZATION_SETTINGS_LOADING = '@@generalSettings/set-organization-settings-loading',
    CREATE_ORGANIZATION_SETTINGS = '@@generalSettings/create-organization-settings',
    UPDATE_ORGANIZATION_SETTINGS = '@@generalSettings/update-organization-settings',
    UPDATE_ORGANIZATION_SETTINGS_SUCCESS = '@@generalSettings/update-organization-settings-success',
    SET_ORGANIZATION_SETTINGS_SAVING = '@@generalSettings/set-organization-settings-saving'
}

export const generalSettingsActions = {
    getOrganizationSettings: () => createAction(GeneralSettingsActionTypes.GET_ORGANIZATION_SETTINGS),
    setOrganizationSettings: (payload: { organizationMetadata: OrganizationMetadataDTO | null }) =>
        createAction(GeneralSettingsActionTypes.SET_ORGANIZATION_SETTINGS, payload),
    setOrganizationSettingsLoading: (payload: { loading: boolean }) =>
        createAction(GeneralSettingsActionTypes.SET_ORGANIZATION_SETTINGS_LOADING, payload),
    createOrganizationSettings: (payload: { data: OrganizationMetadataCreateDTO }) =>
        createAction(GeneralSettingsActionTypes.CREATE_ORGANIZATION_SETTINGS, payload),
    updateOrganizationSettings: (payload: { id: string; data: OrganizationMetadataPatchDTO }) =>
        createAction(GeneralSettingsActionTypes.UPDATE_ORGANIZATION_SETTINGS, payload),
    updateOrganizationSettingsSuccess: (payload: { organizationMetadata: OrganizationMetadataDTO }) =>
        createAction(GeneralSettingsActionTypes.UPDATE_ORGANIZATION_SETTINGS_SUCCESS, payload),
    setOrganizationSettingsSaving: (payload: { saving: boolean }) =>
        createAction(GeneralSettingsActionTypes.SET_ORGANIZATION_SETTINGS_SAVING, payload)
}

export type GeneralSettingsActions = ActionsUnion<typeof generalSettingsActions>
